import { render, staticRenderFns } from "./inviteAudit.vue?vue&type=template&id=2938674b&scoped=true&"
import script from "./inviteAudit.vue?vue&type=script&lang=js&"
export * from "./inviteAudit.vue?vue&type=script&lang=js&"
import style0 from "./inviteAudit.vue?vue&type=style&index=0&id=2938674b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2938674b",
  null
  
)

export default component.exports